// extracted by mini-css-extract-plugin
module.exports = {"container":"_2RIOZJ3crSATWdIZlIHFoS"};